import { useParams } from "react-router";

import { DealShow } from "./DealShow";

/**
 * A deal on a phone.
 *
 * DealShow is a dialog the Kanban opens over itself, taking `open` and `id`
 * rather than reading the route. The mobile list is a real list with real rows,
 * so its rows navigate to /deals/:id/show and this adapts that route to the
 * props the dialog expects. Closing redirects back to the list, which is what
 * the dialog already does.
 */
export const MobileDealShow = () => {
  const { id } = useParams<{ id: string }>();
  return <DealShow open id={id} />;
};

export default MobileDealShow;
